import { Component, Input, OnInit } from "@angular/core";
import { Question } from "src/app/Models/question.interface";

@Component({
  selector: "question-instructions",
  templateUrl: "./question-instructions.component.html",
  styleUrls: [
    "./question-instructions.component.css",
    "../../templates/question-template/question-template.component.scss",
  ],
})
export class QuestionInstructionsComponent implements OnInit {
  @Input() config;
  @Input() question: Question;
  constructor() {}

  ngOnInit(): void {}
}
